export default __webpack_public_path__ + "static/sintonizados-image-0068524cd43bd527b746970b612da89b.png";